import type { FC, ReactNode } from 'react'

import { useEffect, useRef, useState } from 'react'
import { Logo } from '@/components/generals/logo'

interface DrawLogoProps {
    className?: string
    title?: string
    decorative?: boolean
}

/** The signature drawn when it scrolls into view. Renders finished on the server. */
export const DrawLogo: FC<DrawLogoProps> = ({ className, title, decorative }): ReactNode => {
    const ref = useRef<HTMLDivElement>(null)
    const [draw, setDraw] = useState<boolean | 'pending'>(false)

    useEffect(() => {
        const el = ref.current

        if (!el || !('IntersectionObserver' in window)) return
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

        const rect = el.getBoundingClientRect()

        if (rect.top < window.innerHeight && rect.bottom > 0) return

        setDraw('pending')

        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return

            setDraw(true)
            observer.disconnect()
        }, { rootMargin: '0px 0px -20% 0px' })

        observer.observe(el)

        return () => observer.disconnect()
    }, [])

    return (
        <div ref={ref} className={className}>
            <Logo draw={draw} title={title} decorative={decorative} className='w-full' />
        </div>
    )
}
